import { use } from 'react';
import { redirect } from 'next/navigation';
import { createFetch, IOptions, logError } from './api';

const isDev = process.env.NODE_ENV === 'development';
const serverFetch = async <T>(url: string, options: IOptions) => {
  try {
    if (options.logger && !isDev) {
      console.log('【Fetch Request】', url, { _requestOptions: options });
    }
    const { skipIntercept = false, ...otherProps } = options;
    const res = (await createFetch(
      url,
      (options = { ...otherProps })
    )) as Response;

    if (!res.ok && !skipIntercept) {
      switch (res.status) {
        case 401:
        case 403:
          logError('error', url, options.method || 'GET', {
            message: '未授权',
          });

          redirect(process.env.NEXT_PUBLIC_APP_SERVER_URL + '/login');
      }
    }
    const data = res.json ? await res?.json() : res;
    if (options.logger && !isDev) {
      console.log('【Fetch Response】', url, {
        _requestOptions: options,
        _responseData: data,
      });
    }
    return data as T;
  } catch (error: any) {
    console.error('【Fetch Error】', url, { _requestOptions: options });
    console.error(error);
    throw error;
  }
};

export const ServerApi = {
  async get<T>(url: string, options: IOptions = {}) {
    return await serverFetch<T>(url, options);
  },
  async post(url: string, data: any = {}, options: IOptions = {}) {
    const res = await serverFetch<{ data: any }>(url, {
      data,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      ...options,
    });
    return res?.data;
  },
};

export const useServerGet = <T>(url: string, options: IOptions = {}) => {
  return use(ServerApi.get<any>(url, options));
};

export const useServerPost = (
  url: string,
  data: any = {},
  options: IOptions = {}
) => {
  return use(ServerApi.post(url, data, options));
};

//TODO 标注化后再去掉 开放平台专用
export const assertError = (data: any) => {
  if (!data) {
    return redirect('/500');
  }
  switch (data.code) {
    // 参数错误
    case 3000:
    // 无数据
    // eslint-disable-next-line no-fallthrough
    case 3004:
      console.error(data.msg);
      return redirect('/404');
  }

  return data;
};
